export default {
    readOnly: 'This customer profile is read-only.',
    actionContext: {
        loadFailed: 'Unable to load customer action availability. Please try again.',
        preflightFailed: 'Unable to start this action. Please try again.',
        reasons: {
            loading: 'Checking whether this action is available.',
            noEligibleTargetLead: 'No eligible lead is available for this customer.',
            notAuthorized: 'You are not authorized to perform this action.',
            preparing: 'Preparing this action.',
            readNotActivated: 'Customer Profile actions are not available for this account.',
            unavailable: 'This action is currently unavailable.',
            writeNotActivated: 'Customer Profile editing is not enabled for this account.',
        },
    },
    contactTab: {
        address: 'Address',
        accessibility: {
            emailAddress: 'Email address {index}',
            emailType: 'Email type {index}',
            newEmailAddress: 'New email address',
            newEmailType: 'New email type',
            newPhoneExtension: 'New phone extension',
            newPhoneNumber: 'New phone number',
            newPhoneType: 'New phone type',
            phoneExtension: 'Phone extension {index}',
            phoneNumber: 'Phone number {index}',
            phoneType: 'Phone type {index}',
        },
        addEmail: 'Add email',
        addPhone: 'Add phone',
        additionalContact: 'Additional Contact',
        birthdayInDays: 'Birthday in {count} days!',
        birthdayToday: 'Birthday today!',
        communicationPreferences: {
            email: 'Email',
            phone: 'Phone',
            sms: 'SMS',
        },
        confirmDelete: 'Select again to confirm deletion',
        contactNumber: 'Contact {number}',
        customerType: 'Customer Type',
        customerTypes: {
            business: 'Business',
            person: 'Person',
        },
        currentCustomerType: 'Customer Type: {customerType}',
        fields: {
            city: 'City',
            contactInformation: 'Contact Information',
            communicationPreference: 'Contact Preference',
            country: 'Country',
            dateOfBirth: 'Date of Birth',
            email: 'Email',
            extension: 'ext. {extension}',
            firstName: 'First Name',
            gender: 'Gender',
            homeEmail: 'Home Email',
            homePhone: 'Home Phone',
            language: 'Language',
            lastName: 'Last Name',
            mobilePhone: 'Mobile Phone',
            otherEmail: 'Other Email',
            postalCode: 'Postal Code',
            province: 'Province',
            streetAddress: 'Street Address',
            streetAddress2: 'Address Line 2',
            title: 'Title',
            workEmail: 'Work Email',
            workPhone: 'Work Phone',
        },
        homeContact: 'Home Contact',
        deleteEmail: 'Delete email',
        deletePhone: 'Delete phone',
        emailTypes: {
            home: 'Home',
            other: 'Other',
            work: 'Work',
        },
        emails: 'Emails',
        extension: 'Extension',
        invalidEmail: 'Enter a valid email address.',
        invalidPhone: 'Enter a valid Canadian or US phone number.',
        invalidContact: 'Invalid contact information',
        notes: 'Notes',
        noteEditorLabel: 'Customer notes',
        notePlaceholder: 'Add a note about this customer',
        noteSaving: 'Saving note…',
        save: 'Unable to save the note. Please try again.',
        validation: 'Notes must be 250 characters or fewer.',
        notPreferred: 'Not preferred',
        personalDetails: 'Personal Details',
        preferred: 'Preferred',
        primaryContact: 'Primary Contact',
        primaryBadge: 'Primary',
        requiredEmail: 'An email address is required. Use delete to remove this email.',
        requiredPhone: 'A phone number is required. Use delete to remove this phone.',
        phoneTypes: {
            home: 'Home',
            mobile: 'Mobile',
            work: 'Work',
        },
        phones: 'Phones',
        updateFailed: 'Unable to save this change. The confirmed value was kept.',
        workContact: 'Work Contact',
    },
    contactDetails: {
        call: 'Call',
        dateOfBirth: 'Date of Birth',
        homeEmail: 'Home Email',
        mobilePhone: 'Mobile Phone',
        notes: 'Notes',
        readLess: 'Read Less',
        readMore: 'Read More',
        seeAll: 'View All Contact Details',
        sendEmail: 'Send Email',
        sms: 'SMS',
        workPhone: 'Work Phone',
    },
    error: {
        loadFailed: 'Unable to load customer profile.',
        actionsLoadFailed: 'Lead actions are unavailable right now.',
        leadDetailsLoadFailed: 'Unable to load lead details.',
        sectionLoadFailed: 'Unable to load this section.',
        retry: 'Retry',
    },
    header: {
        associate: 'Associate',
        customer: 'Customer',
        lastContacted: 'Last Contacted',
        more: 'More',
        never: 'Never',
        noActiveLead: 'No active lead to add a note to',
        startVisit: 'Start Visit',
        status: 'Status',
        unassigned: 'Unassigned',
    },
    sensitiveInfo: {
        hiddenValue: 'Sensitive value hidden',
    },
    notes: {
        addNote: 'Add Note',
        allNotes: 'All Notes',
        saveError: 'Unable to save the note. Please try again.',
        deleteError: 'Unable to delete the note. Please try again.',
        loadNoteError: 'Unable to load this note. Please try again.',
        loadForEditError: 'Unable to load this note for editing. Please try again.',
        loadForReplyError: 'Unable to load this note for replying. Please try again.',
        refreshError: 'Unable to refresh notes. Reload to see the latest changes.',
    },
    sections: {
        activityFeed: 'Activity Feed',
        contactDetails: 'Contact Details',
        sales: 'Sales',
        service: 'Service',
        tradeIn: 'Trade In',
    },
    activityFeed: {
        bookmarkUpdateFailed: 'Unable to update this bookmark.',
        taskRefreshFailed:
            'Task completed, but the activity feed could not refresh. Reload to see the latest changes.',
        search: 'Search',
        datePicker: 'Select dates',
        filters: {
            all: 'All',
            bookmarked: 'Bookmarked',
            note: 'Note',
            call: 'Call',
            sms: 'SMS',
            email: 'Email',
            messenger: 'Messenger',
            video: 'Video',
            appointment: 'Appointment',
            task: 'Task',
        },
        division: {
            sales: 'Sales',
            service: 'Service',
        },
        sections: {
            upcoming: 'Upcoming',
            past: 'Past',
        },
        rollup: {
            seeAll: 'See All {count} Automated Items',
            seeLess: 'See Less',
        },
        timestamp: {
            yesterday: '1 day ago',
        },
        emptyState: {
            title: 'No activity yet',
            description: 'Activity will appear here once interactions are logged.',
        },
        inboundCall: 'Inbound Call',
        outboundCall: 'Outbound Call',
        inboundSms: 'Inbound SMS',
        outboundSms: 'Outbound SMS',
        inboundEmail: 'Inbound Email',
        outboundEmail: 'Outbound Email',
        inboundMessenger: 'Inbound Facebook Message',
        outboundMessenger: 'Outbound Facebook Message',
        inboundVideo: 'Inbound Video Call',
        outboundVideo: 'Outbound Video Call',
        note: 'Note',
        appointment: 'Appointment',
        task: 'Task',
        newLead: 'New Lead',
        unknownEvent: 'Activity',
        unknownEventDescription: 'This activity type is not supported yet.',
        automated: 'Automated',
        receptionist: 'Receptionist',
        private: 'Private',
        newMessage: 'New Message',
        noteReply: 'Note Reply',
        newLeadReceived: 'New lead has been received for this customer.',
        source: 'Source',
        form: 'Form',
        comments: 'Comments',
        confirmed: 'Confirmed',
        canceled: 'Canceled',
        noShow: 'No Show',
        overdue: 'Overdue',
        callStatus: {
            answered: 'Answered',
            attempted: 'Attempted',
            calling: 'Calling',
            delivery_failed: 'Delivery failed',
            error: 'Error',
            interrupted: 'Interrupted',
            invalid: 'Invalid',
            pending: 'Pending',
            unanswered: 'Unanswered',
            voicemail: 'Voicemail',
        },
        actions: {
            reply: 'Reply',
            view: 'View',
            viewSourceDetails: 'View Source Details',
            viewLead: 'View Lead',
            markAsComplete: 'Mark as Complete',
            markAsRead: 'Mark as Read',
        },
        view: {
            communicationUnavailable: 'This activity can no longer be opened. Please try again.',
            staleMobilePhone:
                'This SMS used a phone number that is no longer available for this customer.',
            callTitle: 'Call Details',
            emailTitle: 'Web Lead Email',
            messengerTitle: 'Messenger Details',
            noSubject: '(No subject)',
            apiSource: 'API',
            userSource: 'User',
        },
        reply: {
            communicationUnavailable:
                'This activity can no longer be opened for reply. Please try again.',
            noCurrentEmail:
                'Email is unavailable because the customer has no valid current email address.',
            noCurrentMobilePhone:
                'SMS is unavailable because the customer has no valid current mobile number on this lead.',
            legacyPhoneSelectionUnavailable:
                'This SMS activity used an outdated number, and legacy SMS cannot open a specific current number. No conversation was opened.',
            emailMismatch:
                'The email address used for this activity no longer matches the current customer data. Choose a current address to continue.',
        },
    },
    status: {
        pending: 'Pending',
        attempted: 'Attempted',
        reached: 'Reached',
        engaged: 'Engaged',
        needsAttention: 'Needs Attention',
    },
    sales: {
        seeAllLeads: 'View All Sales Leads',
        viewSourceDetails: 'View Source Details',
        noLeads: 'No sales leads yet',
        addNewLead: 'Add New Sales Lead',
        bdcAgent: 'BDC Agent',
        fniManager: 'F&I Manager',
        secondAssociate: 'Second Associate',
        progressSteps: {
            vehicle: 'Vehicle',
            tradeIn: 'Trade In',
            visit: 'Visit',
            sale: 'Sale',
            credit: 'Credit',
            delivery: 'Delivery',
        },
    },
    currentLeads: {
        title: 'Active Leads',
        merged: '{count} Merged Leads',
        lastUpdated: 'Last updated',
        addedOn: 'Added on',
        emptyVehicles: 'No vehicle of interest is available for this lead.',
        noMatchingVehicles: 'No vehicles match the selected filters.',
        actions: {
            addLead: 'Add New Lead',
            hideSensitive: 'Hide Sensitive Information',
            showSensitive: 'Show Sensitive Information',
            viewSourceDetails: 'View Source Details',
            findMatches: 'Find Matches',
            open: 'Open lead',
            share: 'Share lead',
            print: 'Print lead',
            export: 'Export lead',
            expand: 'Expand lead details',
            collapse: 'Collapse lead details',
            addVehicle: 'Add Vehicle',
            filterSort: 'Filter & Sort',
            viewPricing: 'View Pricing',
            vehicleDetails: 'Vehicle Details',
            actions: 'Actions',
        },
        progress: {
            vehicle: 'Vehicle of Interest',
            tradeIn: 'Trade In',
            visit: 'Visit',
            sale: 'Sale',
            credit: 'Credit',
            creditAndFi: 'Credit & F&I',
            delivery: 'Delivery',
        },
        workflow: {
            loading: 'Loading lead workflow…',
            openError: 'Unable to open this workflow for the selected lead.',
            retry: 'Retry',
        },
        assignment: {
            loading: 'Loading assignments…',
            openError: 'Unable to load assignments for the selected lead.',
            retry: 'Retry',
            saveError: 'Unable to update this assignment. Please try again.',
        },
        matching: {
            title: 'Sales Journey Attribution',
            journeyCount: '{count} journey events',
            opportunityTitle: "{name}'s Sales Opportunity",
            mergedLeads: '{count} Merged Leads',
            potentialMatches: "Potential Matches to Attribute to {name}'s Sales Opportunity",
            addToDeal: 'Add to Deal',
            loading: 'Loading matching leads…',
            openError: 'Unable to find matches for the selected lead.',
            candidatesError: 'Unable to load matching leads.',
            empty: 'No eligible matching leads were found.',
            retry: 'Retry',
            complete: 'All {count} leads were added to the sales journey.',
            partial: '{count} leads were added before attribution stopped.',
            failed: 'No leads were added to the sales journey.',
        },
        output: {
            title: {
                share: 'Share lead output',
                print: 'Print lead output',
                export: 'Export lead',
            },
            close: 'Close lead output',
            loading: 'Loading the selected lead output…',
            openError: 'Unable to load output options for the selected lead.',
            retry: 'Retry',
            share: {
                selectTemplate: 'Select a PDF template to share.',
                generationError: 'Unable to generate the PDF. Choose a template to retry.',
            },
            reasons: {
                contact_profile_reads_disabled:
                    'Canonical contact output is unavailable for this account.',
                missing_primary_mapping: 'This lead is not linked to a primary contact.',
                inactive_primary_mapping: 'This lead’s primary contact link is inactive.',
                conflicting_primary_mapping: 'This lead has conflicting primary contact links.',
                missing_primary_contact: 'The primary contact linked to this lead is unavailable.',
                ownership_scope_violation:
                    'The selected lead and contact do not belong to the same customer account.',
                missing_advisor: 'Assign a sales associate before exporting to this provider.',
                missing_email: 'Add a valid customer email before sharing.',
                invalid_email: 'The customer email is invalid. Add a valid email before sharing.',
                missing_email_projection:
                    'The customer email is not ready for delivery from this lead.',
                missing_phone:
                    'Add a valid customer phone number before exporting to this provider.',
                invalid_phone:
                    'The customer phone number is invalid. Add a valid number before exporting.',
                missing_personal_data:
                    'Add the required customer name before exporting to this provider.',
                missing_wanted_vehicle: 'Add a wanted vehicle before exporting to this provider.',
            },
        },
        status: {
            active: 'Active',
        },
        assignees: {
            salesAssociate: 'Sales Associate',
            bdcAgent: 'BDC Agent',
            secondAssociate: 'Second Associate',
            fiManager: 'F&I Manager',
        },
        vehicle: {
            stock: 'Stock #',
            vin: 'VIN',
            payment: 'Payment',
            rate: 'Rate',
            term: 'Term',
            months: 'months',
            apr: 'APR',
        },
        modality: {
            financing: 'Finance',
            leasing: 'Lease',
            cash: 'Cash',
        },
        frequency: {
            weekly: 'Weekly',
            bi_weekly: 'Bi-weekly',
            semi_monthly: 'Semi-monthly',
            monthly: 'Monthly',
        },
        empty: {
            title: 'No active leads',
            description: 'Active sales leads will appear here when they are added.',
        },
    },
    pastLeads: {
        title: 'Past Leads',
        status: {
            delivered: 'Delivered',
            lost: 'Lost',
            duplicate: 'Duplicate',
            invalid: 'Invalid',
        },
        actions: {
            expand: 'Expand lead details',
            collapse: 'Collapse lead details',
        },
        detail: {
            loading: 'Loading lead details…',
            error: 'Unable to load this lead’s details.',
            retry: 'Retry',
        },
        empty: {
            title: 'No past leads',
            description: 'Past sales leads will appear here when they become available.',
        },
    },
    service: {
        title: 'Service Leads',
        seeAllLeads: 'View All Service Leads',
        viewSourceDetails: 'View Source Details',
        noLeads: 'No service leads yet',
        addNewLead: 'Add New Service Lead',
        addLeadUnavailable: 'Unable to start service lead creation.',
        serviceAgent: 'Service Agent',
        serviceAdvisor: 'Service Advisor',
        filters: {
            vehicle: 'Select Vehicles',
            dateRange: 'Date range',
        },
        table: {
            sourceType: 'Source Type',
            dateTime: 'Date & Time',
            leadStatus: 'Lead Status',
            advisor: 'Advisor',
            vehicle: 'Vehicle',
        },
        groups: {
            upcoming: 'Upcoming Service Leads',
            past: 'Past Service Leads',
        },
        statuses: {
            reached: 'Reached',
            noShow: 'No Show',
            completed: 'Completed',
            canceled: 'Canceled',
        },
        vehiclePopover: {
            equity: 'Equity',
            appraisalValue: 'Appraisal Value',
            payment: 'Payment',
            positive: 'Positive',
            negative: 'Negative',
            term: '{count} months',
            frequency: {
                bi_weekly: 'two weeks',
                weekly: 'week',
                monthly: 'month',
                semi_monthly: 'half-month',
            },
        },
        progressSteps: {
            appointmentScheduled: 'Appt. Scheduled',
            clientVisited: 'Client Visited',
            plannedPickUp: 'Planned Pick up',
            invoiced: 'Invoiced',
        },
    },
    tradeIn: {
        noVehicles: 'No Trade In vehicle added yet',
        vehicleDetails: 'Vehicle Details',
        openTradeInError: 'Unable to open the trade-in for this lead.',
        vin: 'VIN',
        appraisalValue: 'Appraisal Value',
        payments: 'Payments',
        contractEndDate: 'Contract End Date',
        equity: 'Equity',
        frequency: {
            weekly: 'Weekly',
            bi_weekly: 'Bi-weekly',
            semi_monthly: 'Semi-monthly',
            monthly: 'Monthly',
        },
        modality: {
            financing: 'Finance',
            leasing: 'Lease',
            cash: 'Cash',
        },
    },
    tabs: {
        comingSoon: 'Coming soon',
        overview: 'Overview',
        sales: 'Sales',
        service: 'Service',
        contact: 'Contact',
        history: 'History',
    },
};
